import O1HD from "../../engines/gameEngine";
import data_control from "../../engines/libs/data_control";
import utilsView from "../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../engines/modules/uiModule";
import { CsvFileKind } from "../../modes/define/CsvFileKind";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import dartGame from "./dartGame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class dartWinPage extends cc.Component {

    @property({type:cc.Label,tooltip:"钱文本"})
    lbMoney:cc.Label = null;

    reward:number = 0;

    game:dartGame = null;

    bindData(reward:number,game:dartGame){
        this.reward = reward;
        this.game = game;
        this.updatePage();
    }

    onBtnComit(){
        O1HD.getServices().userSrv.setCoins(this.reward,true);
        if(NormalGameManager._instance.getGameData().firstPassDartFlag){
            NormalGameManager._instance.setGameData({firstPassDartFlag:false});
            let fun = ()=> {
                
            }
            let data = {
                id: "20"
                , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                , onComplete: fun
                , exitLayer:()=>{}
            }
            utilsView.openEventLayer(
                null
                , data
                , UI_Z_INDEX.DIALOG
                );
            }
        this.game.closeThis();
        this.closeThis();
    }

    updatePage(){
        this.lbMoney.string = data_control.getNumberFormat(this.reward);
    }

    closeThis(){
        this.node.destroy();
    }
}
